import React from 'react'
import { MultipleAnswer, Step } from '../../components'

const USES = {
  key: 'mote_use',
  trackingKey: 'mote_uses',
  question: 'How do you expect to use Mote?',
  choices: [
    { icon: '↪️', text: 'Providing Feedback', value: 'feedback' },
    { icon: '📙', text: 'Special Education Support', value: 'spec_ed_sup' },
    { icon: '🌎', text: 'ELL Support', value: 'ell_sup' },
    { icon: '🗣️', text: 'Language Learning', value: 'language_learning' },
    { icon: '🖌️', text: 'Creative Projects', value: 'creative_projects' },
    { text: 'Other', value: 'other' }
  ]
}

export const MoteUse = ({ index }) => {
  return (
    <Step
      index={index}
      trackingKey={USES.trackingKey}
      itemsCount={USES.choices.length}
      mode='multiple'
      title={USES.question}
      subtitle='Select all that apply (Required)'
    >
      {USES.choices.map(({ icon, text, value }) => (
        <MultipleAnswer
          key={`${text}-${value}`}
          question={USES.question}
          surveyKey={USES.key}
          text={text}
          icon={icon}
          value={value}
        />
      ))}
    </Step>
  )
}
